module.exports = __webpack_public_path__ + "img/noimage.20a9a116.png";